import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LanguageService } from '../../../services/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-templates',
  templateUrl: './modal-templates.component.html'
})
export class ModalTemplatesComponent implements OnInit, OnDestroy {
  @Input() type: 'legal' | 'help' = 'legal';
  @Input() language: string = 'es';

  content: SafeHtml = '';
  isLoading: boolean = true;
  hasError: boolean = false;
  errorMessage: string = '';

  // Lista de idiomas disponibles para cada tipo de contenido
  private availableLanguages = {
    legal: ['es'],
    help: ['es']
  };

  constructor(
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private languageService: LanguageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadContent();
  }

  ngOnDestroy(): void {
    // Cleanup si es necesario
  }

  /**
   * Carga el contenido según el tipo y idioma especificados
   */
  private loadContent(): void {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    // Determinar qué idioma usar (actual o español como fallback)
    const availableLangs = this.availableLanguages[this.type];
    const langToUse = availableLangs.includes(this.language) ? this.language : 'es';

    // Construir la ruta del archivo
    const filePath = `/assets/templates/${this.type}/${langToUse}.html`;

    this.http.get(filePath, { responseType: 'text' }).subscribe({
      next: (html) => {
        this.content = this.sanitizer.bypassSecurityTrustHtml(html);
        this.isLoading = false;
      },
      error: (error) => {
        console.error(`Error al cargar el contenido ${this.type}:`, error);
        this.handleError();
      }
    });
  }

  /**
   * Maneja los errores de carga
   */
  private handleError(): void {
    this.isLoading = false;
    this.hasError = true;

    const typeLabel = this.type === 'legal' ? 'legal' : 'de ayuda';
    this.errorMessage = `No se pudo cargar el contenido ${typeLabel}.`;

    // Mostrar contenido de error
    this.content = this.sanitizer.bypassSecurityTrustHtml(
      `<div class="error-message text-center p-4">
        <i class="fas fa-exclamation-triangle text-warning mb-3" style="font-size: 2rem;"></i>
        <h5>Error de carga</h5>
        <p class="text-muted">${this.errorMessage}</p>
        <button class="btn btn-outline-primary" (click)="retryLoad()">Reintentar</button>
      </div>`
    );
  }

  /**
   * Reintenta cargar el contenido
   */
  retryLoad(): void {
    this.loadContent();
  }

  /**
   * Cierra la modal
   */
  closeModal(): void {
    this.activeModal.close();
  }
}
